module.exports = __webpack_public_path__ + "img/asgar.064c01d9.jpg";